import React, { Fragment } from "react";
import Main from "./Main";
import About from "./About";
import Agents from "./Agents/Agents";

import { Helmet } from "react-helmet";

import "./css/home.css";

const Home = (props) => {
  return (
    <Fragment>
      <Helmet>
        <title>Valorant Tracker</title>
        <meta name='description' content='Helmet application' />
      </Helmet>
      <div className='uppercase text-gray-400 text-center text-3xl font-semibold py-5'>
        VALORANT OFFICIAL RELEASE IS THIS SUMMER 2020, STAY TUNED !
      </div>
      <Main></Main>
      <Agents history={props.history}></Agents>
      <About></About>
    </Fragment>
  );
};

export default Home;
